<script setup lang="ts">
type EmbedPanelProps = {
  id?: string
  title?: string
  description?: string
  embeddedHTML: string
}
const props = defineProps<EmbedPanelProps>()
</script>

<template>
  <section class="embed-panel" data-testid="embed-panel">
    <div class="container">
      <h2 v-if="title" class="embed-panel__title">{{ title }}</h2>
      <Markdown v-if="description" :content="description" class="embed-panel__markdown" />
      <div v-if="embeddedHTML" v-dompurify-html="embeddedHTML"></div>
    </div>
  </section>
</template>

<style lang="postcss">
.embed-panel {
  margin-bottom: var(--component-space);

  .embed-panel__title {
    text-align: center;
  }
  .embed-panel__markdown {
    text-align: center;
  }
}
</style>
